/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementExportItemResponse } from './CarpsaleManagementExportItemResponse';

export type CarpsaleManagementExportItemResponseApiRespoonse = {
    data?: CarpsaleManagementExportItemResponse;
    status?: CarpsaleManagementExportItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementExportItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

